"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupersimplifierDocuments = exports.SuperSimplifierContributions = exports.SupersimplifierAccount = exports.SupersimplifierAccounts = void 0;
class SupersimplifierAccounts {
    constructor() {
        this.totalRecords = 0;
        this.skip = 0;
        this.take = 0;
        this.recordsReturned = 0;
        this.data = undefined;
    }
}
exports.SupersimplifierAccounts = SupersimplifierAccounts;
class SupersimplifierAccount {
    constructor() {
        this.accountNumber = '';
        this.name = '';
        this.type = '';
        this.benefits = undefined;
        this.pensionDetails = undefined;
        this.beneficiaries = undefined;
        this.insurances = undefined;
    }
}
exports.SupersimplifierAccount = SupersimplifierAccount;
class SuperSimplifierContributions {
    constructor() {
        this.accountNumber = '';
        this.financialYearEndingYear = 0;
    }
}
exports.SuperSimplifierContributions = SuperSimplifierContributions;
class SupersimplifierDocuments {
    constructor() {
        this.accountNumber = '';
        this.skip = 0;
        this.take = 0;
    }
}
exports.SupersimplifierDocuments = SupersimplifierDocuments;
